(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  let revealObserver;
  let stackGroups = [];
  let ticking = false;

  function prepareReveal(root = document) {
    if (!document.body.classList.contains('blaze-motion-enabled') || prefersReduced.matches) return;
    revealObserver ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('blaze-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    root.querySelectorAll?.('[data-blaze-reveal]').forEach((element, index) => {
      element.style.setProperty('--blaze-delay', `${Math.min(index % 4, 3) * 85}ms`);
      revealObserver.observe(element);
    });

    root.querySelectorAll?.('.content-for-layout[data-template="index"] > .shopify-section:not(:first-child)').forEach((section) => {
      if (section.querySelector('.blaze-no-global-reveal')) return;
      section.classList.add('blaze-auto-reveal');
      revealObserver.observe(section);
    });
  }

  function collectStacks(root = document) {
    root.querySelectorAll?.('[data-blaze-stack]').forEach((group) => {
      if (group.dataset.blazeStackReady) return;
      group.dataset.blazeStackReady = 'true';
      const cards = [...group.querySelectorAll('[data-blaze-stack-card]')];
      if (cards.length > 1) stackGroups.push(cards);
    });
  }

  function updateStacks() {
    if (prefersReduced.matches || window.innerWidth < 990) { ticking = false; return; }
    stackGroups.forEach((cards) => {
      cards.forEach((card, index) => {
        const next = cards[index + 1];
        if (!next) { card.style.setProperty('--blaze-stack-scale', '1'); return; }
        const cardTop = parseFloat(getComputedStyle(card).top) || 90;
        const nextTop = next.getBoundingClientRect().top;
        const range = Math.min(window.innerHeight * .42, card.offsetHeight * .45);
        const progress = clamp((cardTop + range - nextTop) / range, 0, 1);
        card.style.setProperty('--blaze-stack-scale', String(1 - progress * .045));
        card.style.filter = `brightness(${1 - progress * .06})`;
      });
    });
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateStacks);
  }

  function boot(root = document) {
    prepareReveal(root);
    collectStacks(root);
    updateStacks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true }); else boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();